const priceRounding = (price, quantity, amount) => {
  const raw = String(price ?? '').replace(',', '.')
  if ([price, quantity, amount].some(value => value == null || !/^\d+(?:[.,]\d+)?$/.test(String(value)))) return { matches: false, difference: NaN, tolerance: 0 }
  const precision = Math.max(2, (raw.split('.')[1] || '').length)
  const values = [Number(raw), Number(String(quantity ?? '').replace(',', '.')), Number(String(amount ?? '').replace(',', '.'))]
  if (!values.every(Number.isFinite) || values.some(value => value < 0)) return { matches: false, difference: NaN, tolerance: 0 }
  const [p, q, total] = values
  // A printed unit price is rounded independently of the invoice line amount.
  const tolerance = Math.max(0.01, q * 0.5 * 10 ** -precision + 0.005)
  const difference = Math.abs(p * q - total)
  return { matches: difference <= tolerance + 1e-8, difference, tolerance }
}
module.exports = { priceRounding }
